<template>
  <v-container fluid>
    <v-row align="center" justify="center" @keypress.enter="enterClick">
      <v-col cols="12" md="10" sm="10">
        <v-form ref="form" @submit.prevent>
          <v-row align="center" justify="center">
            <v-col cols="10">
              <v-text-field class="pt-8" v-model="query.name" prepend-inner-icon="mdi-magnify" color="grey" outlined
                rounded autofocus />
            </v-col>
            <v-col cols="1">
              <v-btn @click="adhocSearch" :loading="loadingButton" color="blue" fab medium dark>
                <v-img src="../assets/mstile-70x70.png" width="55"></v-img>
              </v-btn>
            </v-col>
            <v-col cols="1">
              <v-tooltip bottom open-delay="250">
                <template v-slot:activator="{ on }">
                  <v-btn @click="openCSVSearchModal" v-on="on" color="blue" fab x-small outlined>
                    <v-icon>mdi-file-table</v-icon>
                  </v-btn>
                </template>
                <span>
                  <small>Upload CSV</small>
                </span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols=10 align="right">
              <v-btn-toggle 
                v-model="typeFilter"
                rounded dense borderless
                mandatory>
                <v-btn value="individual">
                  <v-icon small>fa-user</v-icon>
                </v-btn>
                <v-btn value="entity">
                  <v-icon small>fa-building</v-icon>
                </v-btn>
                <v-btn value="vessel">
                  <v-icon small>fa-ship</v-icon>
                </v-btn>
                <v-btn value="all">
                  <v-icon small>mdi-asterisk</v-icon>
                </v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>

    <!-- results table -->
    <v-slide-y-reverse-transition>
      <template v-if="displayCasesTable">
        <UnresolvedCasesTable :caseReports="caseReports" v-on:onViewCaseReport="openCaseReport"
          tableClass="elevation-5 mt-10" />
      </template>
    </v-slide-y-reverse-transition>

    <!-- case report -->
    <!-- <CaseReport
          v-if="caseReportVisible"
          :visible="caseReportVisible"
          :caseReport="caseReport"
          v-on:onClose="onCaseReportClose"
        /> -->

    <CSVSearch v-if="isCSVSearchVisible" :visible="isCSVSearchVisible" v-on:onConfirmed="onCSVSearchConfirmed"
      v-on:onCancelled="onCSVSearchCancelled" />
  </v-container>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import CSVSearch from "../modals/CSVSearch";
// import CaseReport from "../modals/CaseReport";
import UnresolvedCasesTable from "../components/UnresolvedCasesTable";

export default {
  name: "Search",
  components: { CSVSearch, /*CaseReport,*/ UnresolvedCasesTable },
  data() {
    return {
      searchRequest: {},
      typeFilter: 'all',
      query: {},
      loadingButton: false,
      isCSVSearchVisible: false,
      caseReport: {},
      caseReports: [],
      // caseReportVisible: false,
      displayCasesTable: false,
    };
  },
  computed: {
    ...mapGetters(["getAccountSettings"]),
  },
  methods: {
    ...mapActions(["setGlobalAlert"]),
    enterClick() {
      this.adhocSearch();
    },
    adhocSearch() {
      if (this.query.name) {
        this.doSearch([this.query]);
      }
    },
    openCSVSearchModal() {
      this.isCSVSearchVisible = true;
    },
    onCSVSearchCancelled() {
      this.isCSVSearchVisible = false;
    },
    onCSVSearchConfirmed(request) {
      this.query = {};
      this.isCSVSearchVisible = false;
      this.doSearch(request.batch);
    },
    doSearch(batch) {
      if (!batch) return;

      this.loadingButton = true;
      this.displayCasesTable = false;
      this.searchRequest.cases = batch;

      // tyes button toggle requires value for each button - remove 'all' option
      if(this.typeFilter == 'all'){
        this.searchRequest.types = []
      } else {
        this.searchRequest.types = [this.typeFilter]
      }

      if(this.getAccountSettings && this.getAccountSettings.lists){
        this.searchRequest.sources = this.getAccountSettings.lists;
      }
      
      if(!this.searchRequest.sources || this.searchRequest.sources.length < 1){
        this.searchRequest.sources = ['SDN', 'NONSDN']
      }

      if (batch.length > 10) {

        // For great than 10 cases, use async ad hoc service and alert user to check history/resolution later
        axios
          .post("/api/search/async", this.searchRequest)
          .then(() => {
            this.setGlobalAlert({
              alert: true,
              color: "green",
              alertTitle:
                "Your cases are being screened. Check the History and Resolution pages shortly for results",
            });
          })
          .catch(() => {
            this.setGlobalAlert({
              alert: true,
              color: "red",
              alertTitle: "Oops.",
              alertMessage: "Unable to perform search. Please try again",
            });
          })
          .finally(() => {
            this.loadingButton = false;
          });
      } else {
        // For 10 or fewer cases, screen and display results on search view
        axios
          .post("/api/search/", this.searchRequest)
          .then((res) => {
            /**
             * Decorate case reports with sources
             * caseReport component requires each caseReport to contain sources in order to work
             * with multiple search records from unresolved cases view
             */
            res.data.caseReports.forEach((caseReport) => {
              caseReport.sources = res.data.sources;
              caseReport.searchRecordId = res.data.id;
            });

            if (res.data.caseReports.length == 1) {
              // case report full screen view
              this.$router.push({
                name: "casereport",
                params: {
                  caseReport: res.data.caseReports[0],
                },
              });
            } else {
              this.caseReports = res.data.caseReports;
              this.displayCasesTable = true;
            }
          })
          .catch(() => {
            this.setGlobalAlert({
              alert: true,
              color: "red",
              alertTitle: "Oops.",
              alertMessage: "Unable to perform search. Please try again",
            });
          })
          .finally(() => {
            this.loadingButton = false;
          });
      }
    },
    openCaseReport(caseReport) {
      this.$router.push({
        name: "casereport",
        params: {
          caseReport: caseReport,
        },
      });
    },
  }
};
</script>

<style>
/* Fixes unaligned headers */
.v-data-table-header th {
  white-space: nowrap;
}

#keep .v-navigation-drawer__border {
  display: none;
}
</style>